/**
 * Archivo: AjustesServicios.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 2024-08-20
 * 
 * Descripción:
 * Este fichero contiene las funciones para interactuar con la API de ajustes. 
 * Incluye funciones para borrar la base de datos, eliminar colegiales, mensajes globales, comunicados, menús, boletines y usuarios.
 * 
 * Propósito:
 * Proveer funciones para gestionar las acciones críticas de administración desde el frontend, interactuando con la base de datos a través del backend.
 */

const API = process.env.REACT_APP_API_BASE_URL;

export const borrarBaseDeDatos = async (token) => {
    const url = `${API}/api/ajustes/borrarBaseDeDatos`;
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return { success: data.success, message: data.message };
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
};

export const borrarColegiales = async (token) => {
    const url = `${API}/api/ajustes/borrarColegiales`;
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return { success: data.success, message: data.message };
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
};

export const borrarMensajesGlobales = async (token) => {
    const url = `${API}/api/ajustes/borrarMensajesGlobales`;
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return { success: data.success, message: data.message };
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
};

export const borrarComunicados = async (token) => {
    const url = `${API}/api/ajustes/borrarComunicados`;
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return { success: data.success, message: data.message };
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
};

export const borrarMenus = async (token) => {
    const url = `${API}/api/ajustes/borrarMenus`;
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return { success: data.success, message: data.message };
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
};

export const borrarBoletines = async (token) => {
    const url = `${API}/api/ajustes/borrarBoletines`;
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return { success: data.success, message: data.message };
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
};

export const borrarUsuarios = async (token) => {
    const url = `${API}/api/ajustes/borrarUsuarios`;
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return { success: data.success, message: data.message };
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
};
